import { IApiErrorProps, ApiError } from '@ms/utilities-error/lib/ApiError';
import { IFaceted, pack, Facet } from '../Facet';

/**
 * @internal
 */
export const STATUS_CODE_ZERO = 0;

/**
 * @public
 */
export interface IItemOperationErrorProps extends IApiErrorProps {
  facets?: IFaceted;
}

/**
 * @public
 */
export class ItemOperationError extends ApiError {
  public readonly facets: IFaceted;

  constructor(props: IItemOperationErrorProps) {
    const {
      innerError
    } = props;

    const itemOperationError = innerError instanceof ItemOperationError ? innerError : undefined;
    const apiError = innerError instanceof ApiError ? innerError : undefined;

    const errorData = itemOperationError ? {
      facets: itemOperationError.facets
    } : {};

    const {
      facets = errorData.facets
    } = props;

    const code = apiError ? apiError.code : getCodeFromFacets(facets);

    const nextProps = {
      ...props,
      ...(code ? {
        code
      } : {})
    };

    super(nextProps);

    this.name = 'ItemOperationError';

    this.facets = facets || pack({}, {});
  }
}

function getCodeFromFacets(facets: IFaceted | undefined): string | undefined {
  if (facets) {
    for (const facetId of Object.keys(facets)) {
      const facet = Facet.get(facetId);

      if (facet) {
        return facet.debugName;
      }
    }
  }

  return undefined;
}
